export default __webpack_public_path__ + "static/image-19-35b37769e4e5ad154776f56424cb1ff0.jpg";